import { useDrawer } from 'contexts/DrawerContext';

/* profile */
import { ProfileDetails } from 'drawers/profile/ProfileDetails';
import { EditProfile } from 'drawers/profile/EditProfile';

export const useProfileDrawers = () => {
  const { openDrawer } = useDrawer();

  /* profile */
  const openDrawerProfileDetails = () => {
    openDrawer({ component: ProfileDetails });
  };

  const openDrawerEditProfile = () => {
    openDrawer({ component: EditProfile });
  };

  return {
    /* profile */
    openDrawerProfileDetails,
    openDrawerEditProfile,
  };
};
